import { AuthService } from './../../core/auth.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { take } from 'rxjs/operators';
import { Item } from '../../models/item';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {
  isNewUser = true;
  email = '';
  password = '';
  userName = '';
  role = '';
  client = '';
  errorMessage = '';
  monthly_quota_value= 0;
  used_quota = 0;
  error: { name: string, message: string } = { name: '', message: '' };

  resetPassword = false;

  itemCollection: AngularFirestoreCollection<Item>;
  items: Observable<Item[]>;
  readonly path = 'clients';
  itemDocs: Observable<Item[]>;
  itemData: any;


  constructor(public authService: AuthService, private router: Router, public afs: AngularFirestore) { }

  ngOnInit() {
    if (this.authService.loggedInUserRole !== 'Admin') {
      this.router.navigate(['/home'])
    }
    this.itemDocs = this.getList();
   
   }

  getList(): Observable<Item[]>{
    return this.afs.collection<Item>(this.path)
    .snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Item;
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    }); 
  }
  

  checkUserInfo() {
    if (this.authService.isUserEmailLoggedIn) {
      this.router.navigate(['/home'])
    }
  }

  clearErrorMessage() {
    this.errorMessage = '';
    this.error = { name: '', message: '' };
  }


  onSignUp(): void {
    this.clearErrorMessage();
    this.authService.username_value=this.userName;
    this.authService.client=this.client;
    this.authService.roleuser=this.role;
    this.authService.monthly_quota = this.monthly_quota_value;
    this.authService.used_quota = 0;

    if (this.validateForm(this.email, this.password)) {
      this.authService.signUpWithEmail(this.email, this.password)
        .then(() => {
          alert("User has been saved");
          this.router.navigate(['/users/list'])
        }).catch(_error => {
          
          this.error = _error
          // console.log(this.error);
          // this.router.navigate(['/'])
        })
    }
  }


  validateForm(email: string, password: string): boolean {
    if (email.length === 0) {
      this.errorMessage = 'Please enter Email!'
      return false
    }

    if (password.length === 0) {
      this.errorMessage = 'Please enter Password!'
      return false
    }

    if (password.length < 6) {
      this.errorMessage = 'Password should be at least 6 characters!'
      return false
    }
    this.errorMessage = ''
    return true
  }

  isValidMailFormat(email: string) {
    const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if ((email.length === 0) && (!EMAIL_REGEXP.test(email))) {
      return false;
    }

    return true;
  }

  // sendResetEmail() {
  //   this.clearErrorMessage()

  //   this.authService.resetPassword(this.email)
  //     .then(() => this.resetPassword = true)
  //     .catch(_error => {
  //       this.error = _error
  //     })
  // }
}



// WEBPACK FOOTER //
// ./src/app/auth/create-user/create-user.component.ts